import { useState, useRef, useEffect } from 'react';
export default function useReducedMotion() {
    const { current: mediaQuery } = useRef(window ? window.matchMedia('(prefers-reduced-motion: reduce)') : null);
    const [prefersReducedMotion, setPrefersReducedMotion] = useState(() => !!(mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.matches));
    useEffect(() => {
        const listener = () => {
            setPrefersReducedMotion(!!(mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.matches));
        };
        mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.addEventListener('change', listener);
        return () => {
            mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.removeEventListener('change', listener);
        };
    }, [mediaQuery]);
    return prefersReducedMotion;
}
